// Shared alphabetical sort helpers (case-insensitive, locale-aware).
const cmp = (a, b) => (a || '').localeCompare(b || '', undefined, { sensitivity: 'base' });

const PARTICLES = new Set(['van', 'der', 'den', 'de', 'du', 'le', 'la', 'von', 'des', 'da', 'di', 'del', 'el', 'al', 'ten', 'ter']);

// "Mieke Vermaak" → "Vermaak Mieke"; "Sarah Van Der Merwe" → "Van Der Merwe Sarah".
export const surnameKey = (name) => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) return parts[0] || '';
  let i = parts.length - 1;
  while (i > 1 && PARTICLES.has(parts[i - 1].toLowerCase())) i -= 1;
  return `${parts.slice(i).join(' ')} ${parts.slice(0, i).join(' ')}`;
};

export const bySurname = (a, b) => cmp(surnameKey(a?.name), surnameKey(b?.name));
export const byStudentName = (a, b) => cmp(surnameKey(a?.student_name), surnameKey(b?.student_name));
export const byName = (a, b) => cmp(a?.name, b?.name);
